var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 298.9,
    height: 46.28,
    viewBox: "0 0 298.9 46.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1806",
    "data-name": "Rettangolo 1806",
    width: 219.457,
    height: 46.28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_898",
    "data-name": "Raggruppa 898",
    transform: "translate(-811 -58.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_896",
    "data-name": "Raggruppa 896",
    transform: "translate(811 58.22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1798",
    "data-name": "Rettangolo 1798",
    width: 219.457,
    height: 46.28,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9136",
    "data-name": "Tracciato 9136",
    d: "M45.742,41.263V2.448H2.448V45.742H218.919V41.263Zm-4.478,0H6.927V6.926H41.264Z",
    transform: "translate(-0.955 -0.955)",
    fill: "#cc2229"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1799",
    "data-name": "Rettangolo 1799",
    width: 10.45,
    height: 10.45,
    transform: "translate(7.465 7.464)",
    fill: "#cc2229"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1800",
    "data-name": "Rettangolo 1800",
    width: 10.45,
    height: 10.45,
    transform: "translate(7.465 28.365)",
    fill: "#cc2229"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1801",
    "data-name": "Rettangolo 1801",
    width: 10.45,
    height: 10.45,
    transform: "translate(17.915 17.915)",
    fill: "#cc2229"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1802",
    "data-name": "Rettangolo 1802",
    width: 10.45,
    height: 10.45,
    transform: "translate(28.365 7.464)",
    fill: "#cc2229"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1803",
    "data-name": "Rettangolo 1803",
    width: 10.45,
    height: 10.45,
    transform: "translate(28.365 28.365)",
    fill: "#cc2229"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1804",
    "data-name": "Rettangolo 1804",
    width: 173.21,
    height: 38.816,
    transform: "translate(44.754 1.493)",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_895",
    "data-name": "Raggruppa 895",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_894",
    "data-name": "Raggruppa 894",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9137",
    "data-name": "Tracciato 9137",
    d: "M254.269,16.275a.621.621,0,0,1,.692-.692h3.392a.939.939,0,0,1,.831.45L267.561,28.7c.8,1.211,1.662,2.492,2.562,3.981.138.242.38.207.38-.07-.035-1.419-.1-3.531-.1-4.95V16.275a.621.621,0,0,1,.692-.692h2.77a.622.622,0,0,1,.693.692V39.121a.622.622,0,0,1-.693.692h-3.289a.94.94,0,0,1-.831-.449l-8.481-12.67c-.831-1.211-1.662-2.492-2.562-3.981-.138-.242-.38-.208-.38.07.035,1.419.1,3.531.1,4.95V39.121a.622.622,0,0,1-.693.692h-2.769a.621.621,0,0,1-.692-.692Z",
    transform: "translate(-99.216 -6.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1805",
    "data-name": "Rettangolo 1805",
    width: 4.188,
    height: 24.23,
    rx: 1.135,
    transform: "translate(140.064 9.502)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9138",
    "data-name": "Tracciato 9138",
    d: "M202.629,36.317a8.564,8.564,0,0,1-2.077-.138,1.765,1.765,0,0,1-1.038-.831l-2.8-4.154c-.139-.208-.07-.346.173-.45a6.936,6.936,0,0,0,2.215-1.489,8.455,8.455,0,0,0,0-11.562,7.346,7.346,0,0,0-5.746-2.111h-9.519a.621.621,0,0,0-.693.692V39.121a.621.621,0,0,0,.693.692h2.838a.621.621,0,0,0,.693-.692V31.713a.327.327,0,0,1,.346-.346h3.531a1.146,1.146,0,0,1,1.038.553l3.947,5.885c1.419,2.111,2.8,2.527,5.019,2.527a8,8,0,0,0,1.592-.1.628.628,0,0,0,.485-.657V37.01a.622.622,0,0,0-.693-.692m-6.68-10.039a3.83,3.83,0,0,1-2.839,1h-5.4a.327.327,0,0,1-.346-.346V20.013a.327.327,0,0,1,.346-.346h5.4a3.692,3.692,0,0,1,2.8,1,3.833,3.833,0,0,1,1.108,2.839,3.9,3.9,0,0,1-1.073,2.769",
    transform: "translate(-71.461 -6.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9139",
    "data-name": "Tracciato 9139",
    d: "M136.669,37.46c-1.765-1.731-2.631-3.946-2.631-7.442V16.275a.621.621,0,0,1,.693-.692l2.908.034a.622.622,0,0,1,.692.692V30.572a5.316,5.316,0,0,0,5.642,5.78,5.828,5.828,0,0,0,4.258-1.558,5.683,5.683,0,0,0,1.454-4.222v-14.3a.621.621,0,0,1,.692-.692h2.908a.621.621,0,0,1,.693.692V30.191c0,3.462-.866,5.538-2.6,7.3a10.9,10.9,0,0,1-14.712-.035",
    transform: "translate(-52.302 -6.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9140",
    "data-name": "Tracciato 9140",
    d: "M105.881,17.832c-1.523-1.489-3.254-2.25-6.2-2.25H89.716a.621.621,0,0,0-.693.692V39.121a.622.622,0,0,0,.693.692h2.838a.621.621,0,0,0,.692-.692v-6.3a.328.328,0,0,1,.346-.347h5.954c2.977,0,4.811-.761,6.3-2.25a8.773,8.773,0,0,0,2.457-6.162,8.914,8.914,0,0,0-2.423-6.23m-3.115,9.415a4.278,4.278,0,0,1-3.254,1.142H93.592a.327.327,0,0,1-.346-.346V20.013a.327.327,0,0,1,.346-.346h5.919a4.125,4.125,0,0,1,4.5,4.4,4.333,4.333,0,0,1-1.246,3.185",
    transform: "translate(-34.737 -6.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9141",
    "data-name": "Tracciato 9141",
    d: "M323.918,39.018,314.434,16.1a.751.751,0,0,0-.8-.519h-3.6a.821.821,0,0,0-.8.554l-9.381,22.881c-.207.484.035.8.554.8h3.047a.821.821,0,0,0,.8-.554l1.834-4.535a.524.524,0,0,1,.554-.38H317.03a.523.523,0,0,1,.554.38l1.869,4.535a.821.821,0,0,0,.8.554h3.15c.519,0,.726-.312.519-.8M315.3,30.294h-6.958c-.312,0-.485-.174-.346-.485l1.557-4.05c.693-1.766,1.316-3.393,2.008-5.227.138-.381.346-.381.484,0,.693,1.834,1.316,3.461,2.008,5.227l1.557,4.05c.139.311,0,.485-.311.485",
    transform: "translate(-116.977 -6.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9142",
    "data-name": "Tracciato 9142",
    d: "M337.562,12.626a3.964,3.964,0,1,0,3.964,3.964,3.952,3.952,0,0,0-3.964-3.964m0,7.26a3.309,3.309,0,0,1-3.258-3.3,3.25,3.25,0,0,1,3.258-3.258,3.283,3.283,0,0,1,3.3,3.258,3.342,3.342,0,0,1-3.3,3.3",
    transform: "translate(-130.17 -4.927)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9143",
    "data-name": "Tracciato 9143",
    d: "M340.4,18.961l-.471-.706a1.377,1.377,0,0,0-.51-2.669h-1.765v4.2h.745V18.334h.706l.745,1.1c.315.471.55.471,1.138.432V19.2c-.313,0-.392.039-.588-.235m-1.021-1.334H338.4V16.293h.981a.667.667,0,1,1,0,1.334",
    transform: "translate(-131.753 -6.082)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_897",
    "data-name": "Raggruppa 897",
    transform: "translate(807 58.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M237.4,30.5a3.424,3.424,0,0,1-1.2,2.7,4.454,4.454,0,0,1-3.1,1,9.117,9.117,0,0,1-2.7-.5,6.983,6.983,0,0,1-2.4-1.3l1.2-1.9a6.88,6.88,0,0,0,4,1.5,1.7,1.7,0,0,0,1.3-.4,1.389,1.389,0,0,0,.5-1c0-.6-.8-1.1-2.3-1.6-.1,0-.2-.1-.3-.1-2.4-.7-3.7-1.8-3.7-3.3A2.931,2.931,0,0,1,230,23a4.826,4.826,0,0,1,3.3-1,6.585,6.585,0,0,1,3.8,1.2l-.9,1.8a5.861,5.861,0,0,0-3.1-.9,2.649,2.649,0,0,0-1.4.3,1,1,0,0,0-.6,1,.76.76,0,0,0,.6.8,6.6,6.6,0,0,0,1.1.4,4.951,4.951,0,0,1,1.3.4,4.875,4.875,0,0,1,1.1.4c.3.1.7.4,1.1.6A3.1,3.1,0,0,1,237.4,30.5Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9",
    "data-name": "Tracciato 9",
    d: "M242.7,27.7V34h-2.5V17.7h2.5v6.7a4.363,4.363,0,0,1,1.6-1.7,4.645,4.645,0,0,1,2.3-.6,4.378,4.378,0,0,1,3.2,1.2,4.794,4.794,0,0,1,1.2,3.5V34h-2.5V27.6c0-2.2-.9-3.2-2.7-3.2a3.3,3.3,0,0,0-2.2.8A3.18,3.18,0,0,0,242.7,27.7Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10",
    "data-name": "Tracciato 10",
    d: "M264.2,32.5a5.8,5.8,0,0,1-4.4,1.7,6.2,6.2,0,0,1-4.4-1.7,6.036,6.036,0,0,1,0-8.6,6.278,6.278,0,0,1,8.8,0,6.036,6.036,0,0,1,0,8.6Zm-7-1.5a3.709,3.709,0,0,0,6.4-2.8,3.857,3.857,0,0,0-1-2.8,3.709,3.709,0,0,0-6.4,2.8A3.857,3.857,0,0,0,257.2,31Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11",
    "data-name": "Tracciato 11",
    d: "M275.1,22.2a5.351,5.351,0,0,1,4,1.6,5.8,5.8,0,0,1,1.7,4.3,6.032,6.032,0,0,1-1.7,4.4,5.383,5.383,0,0,1-3.9,1.7,5.25,5.25,0,0,1-4-1.9v6h-2.5v-16h2.5v2A4.593,4.593,0,0,1,275.1,22.2Zm-3.9,6a3.62,3.62,0,0,0,1,2.7,3.391,3.391,0,0,0,5,0,3.693,3.693,0,0,0,1.1-2.7,3.928,3.928,0,0,0-1.1-2.8,3.391,3.391,0,0,0-5,0A3.857,3.857,0,0,0,271.2,28.2Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_12",
    "data-name": "Tracciato 12",
    d: "M283.7,33.7a1.656,1.656,0,0,1-.5-1.2,1.845,1.845,0,0,1,.5-1.2,1.346,1.346,0,0,1,1.2-.5,1.845,1.845,0,0,1,1.2.5,1.656,1.656,0,0,1,.5,1.2,1.845,1.845,0,0,1-.5,1.2,1.656,1.656,0,0,1-1.2.5A1.346,1.346,0,0,1,283.7,33.7Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_13",
    "data-name": "Tracciato 13",
    d: "M289.9,20a1.46,1.46,0,1,1,1.1.5A1.606,1.606,0,0,1,289.9,20Zm2.3,14h-2.5V22.3h2.5Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_14",
    "data-name": "Tracciato 14",
    d: "M298.8,24.3v5.9a1.7,1.7,0,0,0,.4,1.3,1.656,1.656,0,0,0,1.2.5,2.244,2.244,0,0,0,1.5-.8l1,1.7a4.175,4.175,0,0,1-2.9,1.2,4.049,4.049,0,0,1-2.7-1.1,4,4,0,0,1-1.1-2.9V24.2h-1.5v-2h1.5V18.5h2.5v3.7h3.1v2h-3Z",
    fill: "#020203"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.abeffdb1b5018639c28663f7a87b0cc5.svg";
export { ForwardRef as ReactComponent };